import template from './vouches-filter.html';
import AffiliatesFilterController from './vouches-filter.controller';
import './vouches-filter.styl';

let affiliatesFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template,
  controller: AffiliatesFilterController,
  controllerAs: 'vm'
};

export default affiliatesFilterComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/vouches-filter/vouches-filter.component.js
 **/